module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAJ1JREFUOBHtU0EKgCAQXLKvdOw1fUYEKfA9vaZbvUVLg5EtJCSQKPIy4+zuqAMSfXJJKWc8jHNoKaxSYkJrmMY5k4801/g4lbH7jWNIz0ShlBriFU7kqhZaa96vtW6ttR0051zvDcgjpB2DKWooCCFGY8yEfbEocEAS8Vz/21Y0gKMG/RbCLAxzfmVWLIrfOMb+eBRLvAoR50x+O90A+LgurxfTxU0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_WidthMin_disabled.png
// module id = 327
// module chunks = 0